/* eslint-disable react-refresh/only-export-components */
import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export function AuthContextProvider({ children }) {
  const [loginInfo, setLoginInfo] = useState({
    email: "",
    senha: "",
  });
  const [user, setUser] = useState(null);
  const [isUnauthorizedUser, setIsUnauthorizedUser] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [needsCreatePassword, setNeedsCreatePassword] = useState(false);

  const loggedUser = localStorage.getItem("User");

  useEffect(() => {
    if (loggedUser) {
      setUser(JSON.parse(loggedUser));
    }
  }, [loggedUser]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        loginInfo,
        setLoginInfo,
        newPassword,
        setNewPassword,
        needsCreatePassword,
        setNeedsCreatePassword,
        isUnauthorizedUser,
        setIsUnauthorizedUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
